<template>
  <div class="goods-detail-container">
    <!-- 主要内容区域 -->
    <div class="content-area">
      <el-row :gutter="24">
        <!-- 左侧：基本信息 -->
        <el-col :span="12">
          <el-card class="form-card" shadow="always">
            <div class="card-header">
              <h3 class="card-title">
                <i class="el-icon-view"></i>
                商品详情查看
              </h3>
            </div>
            <el-form ref="item" :model="item" label-width="120px" class="goods-form">
              <!-- 基本信息 -->
              <div class="form-section">
                <h4 class="section-title">基本信息</h4>
                <el-form-item label="商品ID">
                  <el-input 
                    v-model="item.id" 
                    disabled 
                    placeholder="商品ID" 
                    size="medium"
                  />
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="品牌名称">
                      <el-input 
                        v-model="item.brand" 
                        disabled 
                        placeholder="品牌名称" 
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品名称">
                      <el-input 
                        v-model="item.name" 
                        disabled 
                        placeholder="商品名称" 
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 商品图片 -->
              <div class="form-section" v-if="item.picture || item.supplePicture || (item.isExpired && item.expiredPicture)">
                <h4 class="section-title">商品图片</h4>
                
                <!-- 未过期状态：1*2布局 -->
                <el-row :gutter="20" v-if="!item.isExpired">
                  <el-col :span="12" v-if="item.picture">
                    <div class="upload-item">
                      <label class="upload-label">到样图</label>
                      <div class="image-display">
                        <img :src="item.picture" class="avatar" />
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" v-if="item.supplePicture">
                    <div class="upload-item">
                      <label class="upload-label">补样图</label>
                      <div class="image-display">
                        <img :src="item.supplePicture" class="avatar" />
                      </div>
                    </div>
                  </el-col>
                </el-row>
                
                <!-- 过期状态：2*2布局 -->
                <div v-if="item.isExpired">
                  <!-- 第一行：到样图和补样图 -->
                  <el-row :gutter="20" style="margin-bottom: 40px;">
                    <el-col :span="12" v-if="item.picture">
                      <div class="upload-item">
                        <label class="upload-label">到样图</label>
                        <div class="image-display">
                          <img :src="item.picture" class="avatar" />
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12" v-if="item.supplePicture">
                      <div class="upload-item">
                        <label class="upload-label">补样图</label>
                        <div class="image-display">
                          <img :src="item.supplePicture" class="avatar" />
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  
                  <!-- 第二行：过期商品图片 -->
                  <el-row :gutter="20">
                    <el-col :span="12" v-if="item.expiredPicture">
                      <div class="upload-item">
                        <label class="upload-label">过期商品图片</label>
                        <div class="image-display">
                          <img :src="item.expiredPicture" class="avatar" />
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <!-- 预留位置，保持2*2布局的对称性 -->
                    </el-col>
                  </el-row>
                </div>
              </div>
              <!-- 商品属性 -->
              <div class="form-section" v-if="item.properties || item.shop || item.location">
                <h4 class="section-title">商品属性</h4>
                <el-row :gutter="20">
                  <el-col :span="12" v-if="item.properties">
                    <el-form-item label="商品属性">
                      <el-input v-model="item.properties" disabled size="medium" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="item.shop">
                    <el-form-item label="所属店铺">
                      <el-input v-model="item.shop" disabled size="medium" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="商品位置" v-if="item.location">
                  <el-input v-model="item.location" disabled size="medium" />
                </el-form-item>
              </div>

              <!-- 价格信息 -->
              <div class="form-section" v-if="item.highPrice || item.lowPrice">
                <h4 class="section-title">价格信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="日常价格">
                      <el-input v-model="item.highPrice" disabled size="medium" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="直播价格">
                      <el-input v-model="item.lowPrice" disabled size="medium" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 时间信息 -->
              <div class="form-section" v-if="item.arrivalTime || item.exp">
                <h4 class="section-title">时间信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12" v-if="item.arrivalTime">
                    <el-form-item label="到样时间">
                      <el-date-picker 
                        v-model="item.arrivalTime" 
                        type="date" 
                        disabled
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="item.exp">
                    <el-form-item label="到期时间">
                      <el-date-picker 
                        v-model="item.exp" 
                        type="date" 
                        disabled
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 商品详情 -->
              <div class="form-section" v-if="item.description || item.num || item.specs || item.material || item.color || item.gifts">
                <h4 class="section-title">商品详情</h4>
                <el-form-item label="商品描述" v-if="item.description">
                  <el-input 
                    type="textarea" 
                    v-model="item.description" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="到样总数" v-if="item.num">
                  <el-input 
                    type="textarea" 
                    v-model="item.num" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="型号/规格" v-if="item.specs">
                  <el-input v-model="item.specs" disabled size="medium" />
                </el-form-item>
                <el-form-item label="材质/香型" v-if="item.material">
                  <el-input 
                    type="textarea" 
                    v-model="item.material" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="颜色/口味" v-if="item.color">
                  <el-input 
                    type="textarea" 
                    v-model="item.color" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="赠品" v-if="item.gifts">
                  <el-input 
                    type="textarea" 
                    v-model="item.gifts" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
              </div>

              <!-- 试样信息 -->
              <div class="form-section" v-if="item.pass !== undefined || item.tryDetails">
                <h4 class="section-title">试样信息</h4>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="通过试样">
                      <el-switch v-model="item.pass" disabled />
                    </el-form-item>
                  </el-col>
                  <el-col :span="18" v-if="item.tryDetails">
                    <el-form-item label="备注">
                      <el-input 
                        type="textarea" 
                        v-model="item.tryDetails" 
                        disabled
                        :maxlength="textMaxLenth" 
                        autosize
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
                            <!-- <el-form-item label="排期">
                                <el-col :span="11">
                                  <el-date-picker type="date"    v-model="item.scheduledFrom" style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                  <el-date-picker type="date"    v-model="item.scheduledTo" style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item> -->
              <!-- 已有资源 -->
              <div class="form-section" v-if="item.has && item.has.length > 0">
                <h4 class="section-title">已有资源</h4>
                <el-form-item label="已拥有资源">
                  <div class="resource-tags">
                    <el-tag 
                      v-for="resource in item.has" 
                      :key="resource" 
                      size="small" 
                      type="success"
                      class="resource-tag"
                    >
                      {{ resource }}
                    </el-tag>
                  </div>
                </el-form-item>
              </div>

              <!-- 附件上传 -->
              <div class="form-section" v-if="item.fileList && item.fileList.length > 0">
                <h4 class="section-title">附件</h4>
                <el-form-item label="附件列表">
                  <div class="file-list">
                    <el-link 
                      v-for="(file, i) in item.fileList" 
                      :key="i" 
                      :href="file.url" 
                      target="_blank" 
                      type="primary"
                      class="file-link"
                    >
                      <i class="el-icon-document"></i>
                      {{ file.name }}
                    </el-link>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </el-card>
        </el-col>

        <!-- 右侧：补样和退样信息 -->
        <el-col :span="12">
          <el-card class="form-card" shadow="always">
            <div class="card-header">
              <h3 class="card-title">
                <i class="el-icon-refresh"></i>
                补样和退样信息
              </h3>
            </div>
            <el-form ref="suppleForm" :model="item" label-width="100px" class="supple-form">
              <!-- 补样信息 -->
              <div class="form-section" v-if="item.suppleTime || item.suppleNum || item.suppleDetails">
                <h4 class="section-title">补样信息</h4>
                <el-form-item label="补样时间" v-if="item.suppleTime">
                  <el-date-picker 
                    v-model="item.suppleTime" 
                    type="date" 
                    disabled
                    style="width: 100%"
                  />
                </el-form-item>
                <el-form-item label="补样数量" v-if="item.suppleNum">
                  <el-input 
                    type="textarea" 
                    v-model="item.suppleNum" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="备注" v-if="item.suppleDetails">
                  <el-input 
                    type="textarea" 
                    v-model="item.suppleDetails" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
              </div>

              <!-- 退样信息 -->
              <div class="form-section" v-if="item.returnTime || item.returnAddress || item.returnNumber || item.returnDetails || (item.returnFileList && item.returnFileList.length > 0)">
                <h4 class="section-title">退样信息</h4>
                <el-form-item label="退样时间" v-if="item.returnTime">
                  <el-date-picker 
                    v-model="item.returnTime" 
                    type="date" 
                    disabled
                    style="width: 100%"
                  />
                </el-form-item>
                <el-form-item label="退样地址" v-if="item.returnAddress">
                  <el-input v-model="item.returnAddress" disabled size="medium" />
                </el-form-item>
                <el-form-item label="退样单号" v-if="item.returnNumber">
                  <el-input v-model="item.returnNumber" disabled size="medium" />
                </el-form-item>
                <el-form-item label="备注" v-if="item.returnDetails">
                  <el-input 
                    type="textarea" 
                    v-model="item.returnDetails" 
                    disabled
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="退样图片" v-if="item.returnFileList && item.returnFileList.length > 0">
                  <div class="file-list">
                    <el-link 
                      v-for="(file, i) in item.returnFileList" 
                      :key="i" 
                      :href="file.url" 
                      target="_blank" 
                      type="primary"
                      class="file-link"
                    >
                      <i class="el-icon-picture"></i>
                      {{ file.name }}
                    </el-link>
                  </div>
                </el-form-item>
              </div>

              <!-- 商品状态 -->
              <div class="form-section">
                <h4 class="section-title">商品状态</h4>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否退样</label>
                      <el-switch v-model="item.isReturned" disabled />
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否过期</label>
                      <el-switch v-model="item.isExpired" disabled />
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否补样</label>
                      <el-switch v-model="item.isSupply" disabled />
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否报损</label>
                      <el-switch v-model="item.isReportLosses" disabled />
                    </div>
                  </el-col>
                </el-row>
              </div>

              <!-- 盘货记录 -->
              <div class="form-section" v-if="inventoryHis && inventoryHis.length > 0">
                <h4 class="section-title">盘货记录</h4>
                <el-table :data="inventoryHis" stripe style="width: 100%" max-height="300px">
                  <el-table-column prop="time" label="时间" width="200px" />
                  <el-table-column prop="details" label="备注" />
                </el-table>
              </div>

              <!-- 直播记录 -->
              <div class="form-section" v-if="item.history && item.history.length > 0">
                <h4 class="section-title">直播记录</h4>
                <el-table 
                  :data="item.history"
                  stripe
                  style="width: 100%"
                  max-height="300px"
                >
                  <el-table-column prop="date" label="历史直播记录" />
                </el-table>
              </div>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
            <!-- <el-col :span="12">
                <div class="grid-content bg-purple" style="margin-top:15px;margin-left:10%;margin-right:10% ">
                    <el-row>
                        <el-card shadow="always">
                            <el-form ref="item" :model="item" label-width="80px" >
                                <el-form-item label="补样时间" >
                                    <el-date-picker v-model="item.suppleTime"  type="date"  style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="补样数量" >
                                  <el-input type="textarea"  v-model="item.suppleNum" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="备注" >
                                    <el-input type="textarea"    v-model="item.suppleDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-divider ></el-divider>
                                <el-form-item label="退样时间" >
                                    <el-date-picker v-model="item.returnTime" type="date"   style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="退样地址" >
                                    <el-input v-model="item.returnAddress"   clearable></el-input>
                                </el-form-item>
                                <el-form-item label="退样单号" >
                                    <el-input v-model="item.returnNumber"   clearable></el-input>
                                </el-form-item>
                                <el-form-item label="备注" >
                                    <el-input type="textarea"   v-model="item.returnDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="退样图片" >
                                    <el-link  v-for="(file, i) in item.returnFileList" :key="(i+1)" :href="file.url" target="_blank" style="width: 100%;">{{file.name}}</el-link>
                                </el-form-item>
                                <el-divider v-if="this.item.history.length > 0"></el-divider>
                                <el-table v-if="this.item.history.length > 0"
                                    :data="item.history"
                                    stripe
                                    style="width: 100%">
                                    <el-table-column
                                    prop="date"
                                    label="历史直播记录">
                                    </el-table-column>
                                    </el-table>
                            </el-form>
                        </el-card>
                    </el-row>
                </div>
            </el-col> -->
        </el-row>
    </div>
</template>

<script>
import { goodsApi, inventoryApi } from '@/api'
export default {
  name: 'GoodsDetail',
  data () {
    return {
      item: {
        id: this.$route.query.id,
        brand: '',
        name: '',
        picture: '',
        supplePicture: '',
        expiredPicture: '',
        shop: '',
        location: '',
        properties: '',
        highPrice: '',
        lowPrice: '',
        exp: '',
        gifts: '',
        description: '',
        arrivalTime: '',
        num: '',
        specs: '',
        material: '',
        color: '',
        tryDetails: '',
        pass: true,
        scheduledFrom: '',
        scheduledTo: '',
        has: [],
        suppleTime: '',
        suppleNum: '',
        suppleDetails: '',

        returnFileList: [],
        returnTime: '',
        returnAddress: '',
        returnNumber: '',
        returnDetails: '',
        fileList: [],
        history: [],
        isReturned: false,
        isExpired: false,
        isSupply: false,
        isReportLosses: false
      },
      textMaxLenth: 300,
      inventoryHis: []
    }
  },
  mounted () {
    this.getItemById()
    this.getInventoryHis()
  },
  methods: {
    async getItemById () {
      try {
        const response = await goodsApi.getById(this.$route.query.id)
        this.item = response
        if (this.item.pass === 'true') {
          this.item.pass = true
        }
        if (this.item.isExpired === 'true') {
          this.item.isExpired = true
        }
        if (this.item.isReturned === 'true') {
          this.item.isReturned = true
        }
        if (this.item.isSupply === 'true') {
          this.item.isSupply = true
        }
        if (this.item.isReportLosses === 'true') {
          this.item.isReportLosses = true
        }
        console.log(this.item.fileList)
      } catch (error) {
        console.error('获取商品详情失败:', error)
        this.$message.error('获取商品详情失败')
      }
    },
    async getInventoryHis () {
      try {
        const response = await inventoryApi.getInventoryHistory(this.item.id)
        this.inventoryHis = response
      } catch (error) {
        console.error('获取盘货历史失败:', error)
        this.$message.error('获取盘货历史失败')
      }
    }
  }
}
</script>
<style scoped>
/* 主容器 */
.goods-detail-container {
  padding: 40px;
  background-color: #ffffff;
  min-height: 100vh;
}

/* 内容区域 */
.content-area {
  max-width: 1600px;
  margin: 0 auto;
}

/* 表单卡片 */
.form-card {
  border-radius: 16px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.card-header {
  padding: 30px 0;
  border-bottom: 2px solid #EBEEF5;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px 16px 0 0;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 表单样式 */
.goods-form, .supple-form {
  padding: 0 40px 40px;
}

.form-section {
  margin-bottom: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  border-left: 6px solid #409EFF;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.form-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title::before {
  content: '';
  width: 6px;
  height: 20px;
  background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

/* 图片显示 */
.upload-item {
  text-align: center;
}

.upload-label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}

.image-display {
  border: 2px solid #EBEEF5;
  border-radius: 8px;
  padding: 10px;
  background-color: #FAFAFA;
}

.avatar {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
  border-radius: 6px;
}

/* 资源标签 */
.resource-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.resource-tag {
  margin: 0;
}

/* 文件列表 */
.file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #F0F9FF;
  border-radius: 6px;
  border: 1px solid #E1F5FE;
  transition: all 0.3s ease;
}

.file-link:hover {
  background-color: #E3F2FD;
  border-color: #BBDEFB;
}

/* 状态项 */
.status-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 15px;
  background-color: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
}

.status-item label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-area .el-col {
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .goods-detail-container {
    padding: 10px;
  }
  
  .form-section {
    padding: 15px;
  }
  
  .status-item {
    padding: 10px;
  }
}

/* Element UI 组件样式优化 */
.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.el-input__inner, .el-textarea__inner {
  border-radius: 6px;
}

.el-card {
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/GoodsDetail.vue